import api from "../../config/Api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const sellerLogin = createAsyncThunk<any, { loginRequest: any; navigate: (path: string) => void }>(
    "sellerAuth/sellerLogin",
    async ({ loginRequest, navigate }, { rejectWithValue }) => {
        try {
            const response = await api.post("/sellers/login", loginRequest);
            
            const jwt = response.data?.jwt;
            if (jwt) {
                localStorage.setItem("jwt", jwt);
                navigate("/seller");
            }
            return response.data;
        } catch (error: any) {
            // Extracts message like "Account is PENDING_VERIFICATION. Access denied."
            const errorMessage = error.response?.data?.message || error.response?.data || error.message;
            return rejectWithValue(errorMessage);
        }
    }
);

export const registerSeller = createAsyncThunk<any, { sellerData: any; navigate: (path: string) => void }>(
    "sellerAuth/registerSeller",
    async ({ sellerData, navigate }, { rejectWithValue }) => {
        try {
            const response = await api.post("/sellers/register-seller", sellerData);

            const jwt = response.data?.jwt;
            if (jwt) {
                localStorage.setItem("jwt", jwt);
                navigate("/seller");
            } else {
                // Auto-login attempt will throw an error if the account is created as PENDING_VERIFICATION
                const loginRes = await api.post("/sellers/login", {
                    email: sellerData.email,
                    password: sellerData.password
                });
                if (loginRes.data?.jwt) {
                    localStorage.setItem("jwt", loginRes.data.jwt);
                    navigate("/seller");
                }
            }

            return response.data;
        } catch (error: any) {
            const errorMessage = error.response?.data?.message || error.response?.data || error.message;
            return rejectWithValue(errorMessage);
        }
    }
);